const productsData = {
    beers: require('./beers.json'),
    wines: require('./wines.json')
};

function receiptRewardsController($rootScope, $scope, $timeout, BreakpointsService) {
    $scope.isSmallFormat = BreakpointsService.isSmallFormat();

    $scope.vm = {
        title: 'SCAN & SAVE',
        offersEndDates: {
            beer: '03/10/23',
            wine: '03/10/23'
        },
        beers: [],
        wines: []
    };

    const EVENTS = {
        DISPLAY_NEWSLETTER_SUBSCRIPTION: 'displayNewsletterSubscription'
    };

    let bwsBotElement = null;

    function updateTitle() {
        $scope.vm.title = !$scope.isSmallFormat
            ? 'SCAN AND SAVE'
            : 'SCAN & SAVE';
    }

    function createRatingData(overallRating = 0) {
        const maxRating = 5;
        const stars = typeof overallRating === 'number'
            ? overallRating
            : 0;
        const ret = [];

        const ratingArray = `${stars}`.split('.');
        const numFullstars = Number(ratingArray[0]);
        const hasHalfStar = Number(ratingArray[1]) > 0;

        /*
        // rating data that match existing BWS star rating css logic.
        // the star rating css relies on reverse order. eg 1st star 'checked' means 5 stars
        // half star means another star within the last full star. eg 3.5 stars means 3rd star has a half star within. 4th star is not half...
        */
        for (let i = maxRating; i > 0; i -= 1) {
            const currentStar = i;
            ret.push({
                checked: currentStar === numFullstars,
                isHalfRating: (i === numFullstars) && hasHalfStar
            });
        }

        return ret;
    }

    function init() {
        updateTitle();

        // convert beers and wines data
        for (const [key, value] of Object.entries(productsData)) {
            /* eslint-disable no-loop-func */
            $scope.vm[key] = value.map((item) => {
                item.ratingData = createRatingData(item.overallRating);
                item.savingsAmount = Number(item.wasPrice) - (Number(item.dollar) + Number(item.cents));
                return item;
            });
        }

        bwsBotElement = document.querySelector('bwsbot');

        // hide chat bot
        if (bwsBotElement) {
            bwsBotElement.setAttribute('hidden', 'true');
        }
    }

    init();

    // global events
    $scope.$on('window:resize', function () {
        $scope.$apply(function () {
            $scope.isSmallFormat = BreakpointsService.isSmallFormat();
            updateTitle();
        });
    });

    // hide footer newsletter subscription
    $timeout(() => {
       $rootScope.$emit(EVENTS.DISPLAY_NEWSLETTER_SUBSCRIPTION, false);
    }, 1000);

    // show footer on unmount
    $scope.$on('$destroy', () => {
        $rootScope.$emit(EVENTS.DISPLAY_NEWSLETTER_SUBSCRIPTION, true);

        if (bwsBotElement) {
            bwsBotElement.removeAttribute('hidden');
        }
    });
 }

 module.exports = {
    bindings: {
        groupId: '@'
    },
    controllerAs: 'vm',
    controller: [
        '$rootScope',
        '$scope',
        '$timeout',
        'BreakpointsService',
        'carouselConfig',
        receiptRewardsController
    ],
    template: require('./receipt-rewards.html')
 };



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/receipt-rewards/receipt-rewards.js
 **/